import { useSearchParams } from 'react-router-dom';
import { Input } from '@/components/ui/Input';
import { JournalFeed } from '@/components/journal/JournalFeed';

export function JournalPage() {
  const [params, setParams] = useSearchParams();
  const symbol = params.get('symbol') ?? '';

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Journal</h1>
          <p className="text-sm text-gray-500 mt-1">Narrative log of trade events across all chains</p>
        </div>
        <Input
          value={symbol}
          onChange={(e) => {
            const v = e.target.value.trim().toUpperCase();
            setParams(v ? { symbol: v } : {}, { replace: true });
          }}
          placeholder="Filter symbol…"
          className="w-36"
        />
      </div>

      <JournalFeed symbol={symbol || undefined} title={symbol ? `${symbol} journal` : 'All entries'} />
    </div>
  );
}
